import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ValidationUtilityService } from '../../../shared/utils/validation.util/validation-utility.service';
import { MASK_CONSTANTS } from '../../../../constants/mask.constants';

export interface DialogData {
	city?: string;
	zipCode?: string;
	state?: string;
}

export interface DialogResponseData {
	city?: string;
	zipCode?: string;
	state?: string;
}

/**
 * Add location component
 */
@Component({
	selector: 'app-add-location',
	templateUrl: './add-location.component.html',
	styleUrls: ['./add-location.component.scss'],
})
export class AddLocationComponent implements OnInit {
	/** Location bean (City, state, zip) */
	locations: DialogResponseData[] = [];
	/** Location Form group */
	locationForm: FormGroup;
	/** Zip code display mask */
	zipMask = MASK_CONSTANTS.ZIP;

	/**
	 * Add location constructor
	 * @param dialogRef Reference to a dialog opened via the Material dialog service
	 * @param data Injection token that can be used to access data that was passed in to the dialog
	 */
	constructor(
		public dialogRef: MatDialogRef<AddLocationComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {}

	/**
	 * Component initialization
	 */
	ngOnInit() {
		this.locationForm = this.generateAddAddressForm();
		// this.generateAddAddressForm();
	}

	/**
	 * Close modal dialog on cancel
	 */
	onNoClick(): void {
		this.dialogRef.close();
	}

	/**
	 * Generating address form
	 */
	generateAddAddressForm() {
		return new FormGroup({
			city: new FormControl('', Validators.compose([Validators.required])),
			state: new FormControl('', Validators.compose([Validators.required])),
			zipCode: new FormControl(
				'',
				Validators.compose([Validators.required, ValidationUtilityService.zipCodeValidator])
			),
			// selectedLocations: new FormArray([])
		});
	}

	/**
	 * Close modal dialog and emit data
	 */
	closeModal() {
		this.dialogRef.close(this.data);
	}

	/**
	 * Detecting modal action performed
	 */
	actionFunction(e) {
		const locationInfo = this.locationForm.getRawValue();

		if (e.value === 'submit') {
			const result = {
				city: locationInfo.city,
				state: locationInfo.state,
				zip: locationInfo.zipCode,
			};
			if (this.locationForm.valid) {
				this.dialogRef.close(result);
			} else {
				this.locationForm.get('city').markAsTouched();
				this.locationForm.get('state').markAsTouched();
				this.locationForm.get('zipCode').markAsTouched();
			}
		} else {
			this.onNoClick();
		}
	}
}
